import { WebhookEvent, WebhookStatus } from 'modules/admin/dashboard/types';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';

const STATUS_TONE: Record<WebhookStatus, 'success' | 'warning' | 'danger'> = {
  processado: 'success',
  reprocessando: 'warning',
  falhou: 'danger',
};

interface WebhookEventsTableProps {
  events: WebhookEvent[];
}

export function WebhookEventsTable({ events }: WebhookEventsTableProps) {
  return (
    <Card className="p-0">
      <h3 className="p-5 pb-0 font-heading font-semibold text-ink">Eventos de webhook recentes</h3>

      <div className="mt-4 overflow-x-auto">
        <table className="w-full min-w-[560px] text-sm">
          <thead>
            <tr className="border-t border-border/40 text-left text-xs uppercase tracking-wide text-ink-secondary">
              <th className="px-5 py-2 font-medium">Evento</th>
              <th className="px-5 py-2 font-medium">Provedor</th>
              <th className="px-5 py-2 font-medium">Arena</th>
              <th className="px-5 py-2 font-medium">Status</th>
              <th className="px-5 py-2 font-medium">Quando</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event) => (
              <tr key={event.id} className="border-t border-border/40">
                <td className="px-5 py-3 font-mono text-xs text-ink">{event.eventType}</td>
                <td className="px-5 py-3 text-ink-secondary">{event.provider}</td>
                <td className="px-5 py-3 text-ink-secondary">{event.arenaName}</td>
                <td className="px-5 py-3">
                  <Badge tone={STATUS_TONE[event.status]} className="capitalize">
                    {event.status}
                  </Badge>
                </td>
                <td className="px-5 py-3 text-ink-secondary">{event.dateLabel}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
